<template>
  <div class="content">
    <div class="md-layout">
      <div class="md-layout-item md-medium-size-100 md-size-75">
        <md-card>
          <md-card-header class="md-card-header-icon md-card-header-primary">
            <div class="card-text">
              <h4 class="title">
                <strong>Quote -</strong> {{ quote.serialNo }}
              </h4>
            </div>
            <edit-button
              v-if="isEditable"
              :stateId="quote.stateId"
              @edit-click="editQuote"
            ></edit-button>
          </md-card-header>
          <md-card-content>
            <div class="md-layout">
              <div class="md-layout-item md-small-size-100 md-size-25">
                <p
                  v-bind:class="'text-' + quoteStatus(quote.quoteStatus).colour"
                >
                  <strong>Status:</strong><br />
                  {{ quoteStatus(quote.quoteStatus).name }}
                </p>
                <p>
                  <strong>Quote Type:</strong><br />
                  {{ quoteType(quote.quoteType).name }}
                </p>
                <p>
                  <strong>Priority:</strong><br />
                  {{ quotePriority(quote.quotePriority).name }}
                </p>
              </div>
              <div class="md-layout-item md-small-size-100 md-size-25">
                <p>
                  <strong>Client</strong><br />
                  {{ quote.clientName }}
                </p>
                <p>
                  <strong>Site</strong><br />
                  {{ quote.siteName }}
                </p>
                <p>
                  <strong>Building</strong><br />
                  {{ quote.buildingName }}
                </p>
              </div>
              <div class="md-layout-item md-small-size-100 md-size-25">
                <p>
                  <strong>Contractor</strong><br />
                  {{ quote.contractorName }}
                </p>
                <p>
                  <strong>Contractor Region</strong><br />
                  {{ quote.contractorRegionName }}
                </p>
              </div>
              <div class="md-layout-item md-small-size-100 md-size-25">
                <p>
                  <strong>Created Date:</strong><br />
                  {{ quote.createdDate | moment("MMMM Do YYYY HH:mm") }}
                </p>
                <p>
                  <strong>Last Updated:</strong><br />
                  {{ quote.lastUpdatedDate | moment("MMMM Do YYYY HH:mm") }}
                </p>
                <p>
                  <strong>Last Updated By:</strong><br />
                  {{ quote.lastUpdatedBy }}
                </p>
              </div>
              <div class="md-layout-item md-small-size-100 md-size-100">
                <br />
              </div>
              <div class="md-layout-item md-small-size-100 md-size-25">
                <div>
                  <strong>Value</strong><br />
                  &#163;{{ quote.value }}
                </div>
              </div>
              <div class="md-layout-item md-small-size-100 md-size-75">
                <div>
                  <strong>Description</strong><br />
                  {{ quote.description }}
                </div>
              </div>
            </div>
          </md-card-content>
          <quote-actions @change-status="changeStatus"></quote-actions>
        </md-card>
        <QuoteNotes @refresh="getQuoteDetails"></QuoteNotes>
      </div>
      <div class="md-layout-item md-medium-size-100 md-size-25">
        <QuoteSummary></QuoteSummary>
      </div>
    </div>
    <QuoteChangeStatusModal
      :showModal="showQuoteModal"
      :newStatusId="selectedStatusId"
      :quoteId="quote.id"
      @closeModal="closeModal"
    ></QuoteChangeStatusModal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  components: {
    QuoteActions: () => import("./components/QuoteActions"),
    QuoteChangeStatusModal: () => import("./components/QuoteChangeStatusModal"),
    QuoteNotes: () => import("./components/QuoteNotes"),
    QuoteSummary: () => import("./components/QuoteSummary")
  },
  async created() {
    await this.getQuoteDetails();
  },
  computed: {
    ...mapGetters({
      quote: "quote/quote",
      quoteStatus: "quote/getQuoteStatus",
      quoteType: "quote/getQuoteType",
      quotePriority: "quote/getQuotePriority",
      isEditable: "quote/isEditable"
    })
  },
  data() {
    return {
      showQuoteModal: false,
      selectedStatusId: -1
    };
  },
  methods: {
    async getQuoteDetails() {
      await this.$store.dispatch(
        "quote/getQuoteDetail",
        this.$route.params.quoteId
      );
    },
    editQuote() {
      this.$router.push({
        name: "Edit Quote",
        params: { quoteId: this.$route.params.quoteId }
      });
    },
    changeStatus(statusId) {
      this.selectedStatusId = statusId;
      this.showQuoteModal = true;
    },
    closeModal(refresh) {
      this.showQuoteModal = false;
      this.selectedStatusId = -1;
      if (refresh) this.getQuoteDetails();
    }
  }
};
</script>

<style></style>
